export const halfDay: Record<"NO" | "YES", number> = {
  NO: 0,
  YES: 1,
};
